<div
  class="tw-flex tw-flex-col tw-justify-between tw-rounded-lg tw-bg-dt-surface-card tw-h-full tw-relative"
>
  <div class="tw-p-7 tw-text-xl tw-font-medium md:tw-text-base">
    <span class="tw-w-full tw-justify-center tw-flex tw-items-center">
      {{ data.title }}
    </span>
    <div
      (click)="this.closeDialog()"
      class="tw-absolute tw-top-6 tw-right-6 xs:tw-top-2 xs:tw-right-2 tw-p-2 tw-bg-dt-surface-elevated tw-rounded-full tw-cursor-pointer"
    >
      <icon [size]="6" [name]="'close'" [currentColor]="'neutral-600'"> </icon>
    </div>
  </div>
  <div class="tw-px-20 tw-mb-7">
    @if (data && data.message) {
      @if (isMessageKey) {
        <p class="tw-mb-4 tw-flex tw-m-0">{{ data.message | i18n }}</p>
      } @else {
        <p class="tw-mb-4 tw-flex tw-m-0">{{ data.message }}</p>
      }
      @if (data.reminder) {
        <span class="tw-flex tw-text-dt-text-secondary tw-font-normal">
          {{ data.reminder }}
        </span>
      }
    }
  </div>
  <div
    class="tw-px-8 tw-py-6 xs:tw-p-4 xs:tw-flex-col xs:tw-gap-1 tw-flex tw-w-full tw-justify-between tw-gap-6 tw-rounded-b-xl tw-bg-dt-surface-elevated"
  >
    <span
      (click)="closeBtnOptions.onClick()"
      class="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-12 tw-text-dt-text-headings tw-font-medium tw-cursor-pointer"
    >
      {{ data.cancel.title }}
    </span>
    <app-gloss-button
      class="tw-w-full"
      [mat-dialog-close]="true"
      [options]="confirmBtnOptions"
    ></app-gloss-button>
  </div>
</div>
